'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _he_IL = require('../vc-pagination/locale/he_IL');

var _he_IL2 = _interopRequireDefault(_he_IL);

var _he_IL3 = require('../date-picker/locale/he_IL');

var _he_IL4 = _interopRequireDefault(_he_IL3);

var _he_IL5 = require('../time-picker/locale/he_IL');

var _he_IL6 = _interopRequireDefault(_he_IL5);

var _he_IL7 = require('../calendar/locale/he_IL');

var _he_IL8 = _interopRequireDefault(_he_IL7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  locale: 'he',
  Pagination: _he_IL2['default'],
  DatePicker: _he_IL4['default'],
  TimePicker: _he_IL6['default'],
  Calendar: _he_IL8['default'],
  Table: {
    filterTitle: 'תפריט סינון',
    filterConfirm: 'אישור',
    filterReset: 'איפוס',
    selectAll: 'בחר הכל',
    selectInvert: 'הפוך בחירה'
  },
  Modal: {
    okText: 'אישור',
    cancelText: 'ביטול',
    justOkText: 'אישור'
  },
  Popconfirm: {
    okText: 'אישור',
    cancelText: 'ביטול'
  },
  Transfer: {
    searchPlaceholder: 'חפש כאן',
    itemUnit: 'פריט',
    itemsUnit: 'פריטים'
  },
  Upload: {
    uploading: 'מעלה...',
    removeFile: 'הסר קובץ',
    uploadError: 'שגיאת העלאה',
    previewFile: 'הצג קובץ',
    downloadFile: 'הורד קובץ'
  },
  Empty: {
    description: 'אין מידע'
  }
};